import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgInitDirective } from './ng-init.directive';
import { ClickOutsideDirective } from '@app/shared/directives/click-outside.directive';
import { DragDropDirective } from '@app/shared/directives/drag-and-drop.derective';
import {ScrollDirective} from '@app/shared/directives/scroll-window.directive'

const directives = [
    NgInitDirective,
    ClickOutsideDirective,
    DragDropDirective,
    ScrollDirective
];

@NgModule({
    imports: [CommonModule],
    declarations: [...directives],
    exports: [...directives]
})
export class DirectivesModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/directives/directives.module.ts